import { FormatSpecifier } from '../../../Lib/Format';
import { FormatTypes } from '../../../Lib/Format/formatType';

/**
 * Returns the placeholder text for a numeric input
 *  based on the format that will be applied to the value
 */
const getPlaceholderFromFormat = (specifier: FormatSpecifier = {}) => {
  let { nearest, precision, type } = specifier;

  // Specifiers have fixed point formatting by default
  type = type || FormatTypes.FixedPoint;

  switch (type) {
    case FormatTypes.SignificantFigures:
      if (!precision || precision <= 0) precision = 6;
      return `To nearest ${precision}sf`;
    case FormatTypes.FixedPoint:
      if (!nearest) {
        if (precision != null && precision >= 0) nearest = 1 / Math.pow(10, precision);
        else nearest = 1;
      }

      return `To nearest ${nearest}`;
    case FormatTypes.AsEntered:
      return 'Enter number';
  }

  // Unsupported format
  return '';
};

export default getPlaceholderFromFormat;
